(function () {

  'use strict';




  const MAX_SELECTED = 10;

  function pxPrintQueueWorkstationRoutingPrefs(
    $filter, $q, $timeout, toastr,
    WorkstationListService, WorkstationListPOSTPaging,
    SUPPORTED_OS
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        resource: '=resource',
        callback: '&callback'
      },
      templateUrl: 'app/components/printQueueProperties/settings/workstationRoutingPrefs/workstationRoutingPrefs.template.html',
      link: function (scope, element) {

        const info = (scope.context && scope.context.printQueue && scope.context.printQueue.info) || {};
        const initialMode = info.workstationRoutingMode || "NONE";
        const initialIds = Array.isArray(info.preferredWorkstations)
          ? info.preferredWorkstations.slice()
          : [];

        const preferredWorkstationsList = Array.isArray(scope.context && scope.context.preferredWorkstationsList)
          ? scope.context.preferredWorkstationsList
          : [];

        const computeNetworkWarning = scope.context.computeNetworkWarning;
        const extractNetworkHrefs = scope.context.extractNetworkHrefs;

        function lookupWorkstation(id) {
          return preferredWorkstationsList.find(function (item) {
            return item && item.info && item.info.id === id;
          });
        }

        function toSelectedEntry(ref) {
          const networkHrefs = Array.isArray(ref.networkHrefs) ? ref.networkHrefs.slice() : [];
          return {
            id: ref.id,
            name: ref.name,
            selfHref: ref.selfHref,
            networkHrefs: networkHrefs,
            networkWarning: computeNetworkWarning(networkHrefs),
            info: ref.info
          };
        }

        scope.draft = {
          mode: initialMode,
          selected: initialIds.map(function (id) {
            const ws = lookupWorkstation(id);
            return toSelectedEntry({
              id: id,
              name: ws && ws.info && ws.info.name ? ws.info.name : id,
              selfHref: ws && ws.info && ws.info._links && ws.info._links.self
                ? ws.info._links.self.href
                : null,
              networkHrefs: extractNetworkHrefs(ws),
              info: ws ? ws.info : { id: id, name: id }
            });
          }),
          searchString: '',
          savePending: false,
          lastError: null
        };

        function recomputeAnyNetworkWarnings() {
          scope.anyNetworkWarnings = scope.draft.selected.some(function (ws) {
            return !!ws.networkWarning;
          });
        }

        recomputeAnyNetworkWarnings();

        scope.maxSelected = MAX_SELECTED;
        scope.atSelectionLimit = function () {
          return scope.draft.selected.length >= MAX_SELECTED;
        };

        scope.supportedOs = SUPPORTED_OS;
        scope.pristineMode = initialMode;
        scope.pristineSelectedIds = initialIds.slice();

        const printerNetworkHref = scope.context?.printerNetwork?.info?._links?.self?.href ?? null;

        scope.workstationListPaging = new WorkstationListPOSTPaging();
        scope.workstationListPaging.pagingCriteria.networkFilters = printerNetworkHref ? [printerNetworkHref] : [];
        scope.workstationListPaging.pagingCriteria.notWorkstations = scope.context.printQueue.info.preferredWorkstations || [];

        scope.list = [];
        scope.totalPages = 0;
        scope.poolLoaded = 0;
        scope.poolTotal = 0;
        scope.loadingPage = false;

        scope.preferredWorkstationsList = [];

        function refToWorkstation(item) {
          const href = item && item.info && item.info._links && item.info._links.self
            ? item.info._links.self.href
            : null;
          const id = href ? href.split('/').pop() : (item && item.customProperties ? item.customProperties.id : null);
          const name = item && item.info && item.info.name ? item.info.name : id;
          return { id: id, name: name, selfHref: href, networkHrefs: extractNetworkHrefs(item), info: item.info };
        }

        function getFirstPage() {
          scope.loadingPage = true;
          scope.workstationListPaging.pagingCriteria.page = 0;
          WorkstationListService.postGetWorkstationListPaged(scope.workstationListPaging).then(function (response) {
            scope.totalPages = response && response.page ? response.page.totalPages : 0;
            scope.poolTotal = response && response.page ? response.page.totalElements : 0;
            scope.list = (response && response.list ? response.list : []).map(refToWorkstation);
            scope.poolLoaded = scope.list.length;
            scope.loadingPage = false;
          }).catch(function () {
            scope.loadingPage = false;
          });
        }

        function getNextPage() {
          if (scope.loadingPage) { return; }
          if (scope.workstationListPaging.pagingCriteria.page + 1 >= scope.totalPages) { return; }
          scope.loadingPage = true;
          scope.workstationListPaging.pagingCriteria.page += 1;
          WorkstationListService.postGetWorkstationListPaged(scope.workstationListPaging).then(function (response) {
            const more = (response && response.list ? response.list : []).map(refToWorkstation);
            scope.list = scope.list.concat(more);
            scope.poolLoaded = scope.list.length;
            scope.loadingPage = false;
          }).catch(function () {
            scope.loadingPage = false;
          });
        }

        scope.textSearch = function () {
          scope.workstationListPaging.pagingCriteria.match = scope.draft.searchString;
          getFirstPage();
        };

        function excludeFromPool(id) {
          const excludedWorkstations = scope.workstationListPaging.pagingCriteria.notWorkstations || [];
          if (!excludedWorkstations.includes(id)) {
            excludedWorkstations.push(id);
          }
          scope.workstationListPaging.pagingCriteria.notWorkstations = excludedWorkstations;
        }

        function includeInPool(id) {
          const excludedWorkstations = scope.workstationListPaging.pagingCriteria.notWorkstations || [];
          const index = excludedWorkstations.indexOf(id);
          if (index !== -1) {
            excludedWorkstations.splice(index, 1);
          }
          scope.workstationListPaging.pagingCriteria.notWorkstations = excludedWorkstations;
        }

        scope.setMode = function (mode) {
          scope.draft.mode = mode;
        };

        scope.addWorkstation = function (workstation) {
          if (!workstation || !workstation.id) { return; }
          if (scope.draft.selected.length >= MAX_SELECTED) { return; }
          const alreadySelected = scope.draft.selected.some(function (w) {
            return w.id === workstation.id;
          });
          if (alreadySelected) { return; }
          scope.list = scope.list.filter(function (item) {
            return item.id !== workstation.id;
          });
          scope.poolLoaded = scope.list.length;
          if (scope.poolTotal > 0) { scope.poolTotal -= 1; }
          excludeFromPool(workstation.id);
          scope.draft.selected.push(toSelectedEntry(workstation));
          recomputeAnyNetworkWarnings();
        };

        scope.removeWorkstation = function (id) {
          const removed = scope.draft.selected.find(function (w) {
            return w.id === id;
          });
          if (!removed) { return; }
          scope.draft.selected = scope.draft.selected.filter(function (w) {
            return w.id !== id;
          });
          includeInPool(id);
          scope.list.unshift({
            id: removed.id,
            name: removed.name,
            selfHref: removed.selfHref,
            networkHrefs: removed.networkHrefs,
            info: removed.info
          });
          scope.poolLoaded = scope.list.length;
          scope.poolTotal += 1;
          recomputeAnyNetworkWarnings();
        };

        scope.isValid = function () {
          const mode = scope.draft.mode;
          const count = scope.draft.selected.length;
          if (mode === 'NONE') { return true; }
          if ((mode === 'PREFERRED' || mode === 'EXCLUSIVE') && count >= 1) { return true; }
          return false;
        };

        scope.isDirty = function () {
          if (scope.draft.mode !== scope.pristineMode) { return true; }
          if (scope.draft.selected.length !== scope.pristineSelectedIds.length) { return true; }
          return scope.draft.selected.some(function (w, i) {
            return w.id !== scope.pristineSelectedIds[i];
          });
        };

        scope.saveDisabled = function () {
          return scope.draft.savePending || !scope.isValid();
        };

        scope.resetSelected = function () {
          scope.draft.selected = [];
          scope.workstationListPaging.pagingCriteria.notWorkstations = [];
          recomputeAnyNetworkWarnings();
          getFirstPage();
        };

        scope.resetMode = function () {
          scope.draft.mode = null;
        };

        scope.onClear = function () {
          scope.draft.mode = null;
          scope.draft.selected = [];
          scope.workstationListPaging.pagingCriteria.notWorkstations = [];
          recomputeAnyNetworkWarnings();
          getFirstPage();
        };

        scope.onCancel = function () {
          scope.callback({ context: false });
        };

        scope.onSave = function () {
          if (scope.draft.savePending) { return; }
          if (!scope.isValid()) { return; }
          const payload = {
            mode: scope.draft.mode,
            workstationIds: scope.draft.selected.map(function (w) { return w.id; })
          };
          scope.draft.savePending = true;
          scope.draft.lastError = null;

          scope.context.printQueue.saveRoutingPreference(payload).then(function () {
            const targetInfo = scope.context.printQueue.info;
            toastr.success($filter('translate')('ChangesSaved'));
            scope.draft.savePending = false;
            scope.callback({ context: false });
          }).catch(function (error) {
            scope.draft.lastError = error;
            scope.draft.savePending = false;
            toastr.error($filter('translate')('WorkstationRouting_SaveError'));
          });
        };

        (function () {
          getFirstPage();
        })();

        element.find('.routing-prefs-pool-scroll').on('scroll', function (event) {
          const scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          const containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scrollEnd > containerHeight) {
            $timeout(function () { getNextPage(); }, 300);
          }
        });

        scope.$on('$destroy', function () {
          element.find('.routing-prefs-pool-scroll').off('scroll');
        });
      }
    };
  }

  pxPrintQueueWorkstationRoutingPrefs.$inject = [
    '$filter', '$q', '$timeout', 'toastr',
    'WorkstationListService', 'WorkstationListPOSTPaging',
    'SUPPORTED_OS'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrintQueueWorkstationRoutingPrefs', pxPrintQueueWorkstationRoutingPrefs);

})();
